import * as Yup from 'yup';
import { bankAccountSchema } from './bank-account-schema.js';
import { billingAddressSchema } from './billing-address-schema.js';
import { personSchema } from './person-schema.js';

const makeValidationSchema = () => {
  const validationSchema = Yup.object().shape({
    isPixKey: Yup.boolean(),
    businessOwner: personSchema.fields.businessOwner,
    billingAddress: billingAddressSchema.fields.billingAddress,
    bankAccount: Yup.mixed().when('isPixKey', {
      is: false,
      then: bankAccountSchema.fields.bankAccount
    })
  });
  return validationSchema;
};

export { makeValidationSchema };
